import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-sucess',
  templateUrl: './sucess.component.html',
  styleUrls: ['./sucess.component.css']
})
export class SucessComponent implements OnInit {
  SucessData;
  constructor(private globalService: GlobalService, private router: Router, private ngxLoader: NgxUiLoaderService) { }

  ngOnInit() {
    this.SucessData = this.globalService.getAppointmentResponce();
  }

  BackHome(){
    this.router.navigate(['/Appointment/' + this.SucessData.BranchId + '/0']);
  }
  navtoMainUrl() {
    if (this.SucessData.PluginHeaderNavigationUrl !== "") {
      window.location.href = this.SucessData.PluginHeaderNavigationUrl;
    } else {
      window.location.href = this.SucessData.RedirectUrl;
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/app/sucess/sucess.component.ts